import { render, staticRenderFns } from "./PreviewCanvas.vue?vue&type=template&id=4e50cee2&scoped=true&"
import script from "./PreviewCanvas.vue?vue&type=script&lang=js&"
export * from "./PreviewCanvas.vue?vue&type=script&lang=js&"
import style0 from "./PreviewCanvas.vue?vue&type=style&index=0&id=4e50cee2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e50cee2",
  null
  
)

export default component.exports